import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import "nprogress/nprogress.css";
import { Router } from "react-router-dom";
import { axHistory } from "./resources/axHistory";
import ScrollToTop from "./resources/scrollTop";
import { GlobalContextProvider } from "./components/context/GlobalContext";
ReactDOM.render(
  <React.StrictMode>
    <Router history={axHistory}>
      <GlobalContextProvider>
        <ScrollToTop />
        <App />
      </GlobalContextProvider>
    </Router>
  </React.StrictMode>,
  document.getElementById("root")
);
